import { render, staticRenderFns } from "./STableClientDebtsComp.vue?vue&type=template&id=78bdedb0&"
import script from "./STableClientDebtsComp.vue?vue&type=script&lang=js&"
export * from "./STableClientDebtsComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports